import {ActionableUserEntity, AllowedAction} from './util-interfaces';
import {UserEntityType} from '@app/shared/services/api/user-entity';
import {Exclude, Expose, Transform} from "class-transformer";
import {CustomizationProperty, SupportedPropertyValueType} from "@shared/services/api/customization-property";
import {CustomizationPropertyName} from "@app/layout/admin/services/api/customer-customization-property.interface";


export interface Customer extends ActionableUserEntity {
  customizationProperties?: Map<string, any>;
}


export const CUSTOMIZATION_PROPERTY_TYPES_BY_NAME = new Map<string, SupportedPropertyValueType>([
  [CustomizationPropertyName.HideBranding, 'boolean'],
  [CustomizationPropertyName.HideIntegrations, 'boolean']
]);


export class CustomerImpl implements Customer {
  @Exclude({toPlainOnly: true})
  type = UserEntityType.CUSTOMER;

  @Expose({name: 'customer_id'})
  id: number;

  @Expose({name: 'customer_name'})
  name: string;

  @Expose({name: 'logo_url'})
  @Transform(({value}) => value ? new URL(value) : value, {toClassOnly: true})
  @Transform(({value}) => value ? value.toString() : value, {toPlainOnly: true})
  logoUrl?: URL;

  @Expose({name: 'customization_properties'})
  @Exclude({toPlainOnly: true})
  @Transform(({value: properties}) => CustomizationProperty.toMap(properties, CUSTOMIZATION_PROPERTY_TYPES_BY_NAME), {toClassOnly: true})
  customizationProperties?: Map<string, any>;

  @Expose({name: 'allowed_actions'})
  @Exclude({toPlainOnly: true})
  allowedActions: (AllowedAction)[];
}
